import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// HIS
import { HisSearchResultComponent } from 'hisng';

@Component( {
    selector: 'psv-unit-search-result',
    templateUrl: './unit-search-result.component.html',
    standalone: false
} )
export class UnitSearchResultComponent implements OnInit {
    private route = inject(ActivatedRoute);

    @ViewChild( HisSearchResultComponent, { static: true } ) searchResultComponent: HisSearchResultComponent;

    public showBackButton = false;

    ngOnInit() {
        this.route.queryParams.subscribe( ( queryParams: any ) => {
            this.showBackButton = queryParams.showBackButton ? queryParams.showBackButton === 'true' : this.showBackButton;
        } );
    }

    /* back to person view */
    back() {
        window.history.back();
    }
}
